import { type AddToWishlistEvent, addToWishlistEventSchema } from './eCommerceTrackingEventSchema';
import logger from '../logger';

export type AddToWishlistEventProps = Omit<AddToWishlistEvent, 'event_name' | 'event'>;

export const buildAddToWishlistEvent = (props: AddToWishlistEventProps): AddToWishlistEvent => {
  const {
    anonymousId,
    authenticatedId,
    ecommerce: { currency, value, item_list_id, item_list_name, items }
  } = props;

  const addToWishlistEvent: AddToWishlistEvent = {
    event: 'ga4_event_ecommerce',
    event_name: 'add_to_wishlist',
    anonymousId,
    authenticatedId,
    ecommerce: {
      currency,
      value,
      ...(item_list_id ? { item_list_id } : {}),
      ...(item_list_name ? { item_list_name } : {}),
      items
    }
  };

  const result = addToWishlistEventSchema.safeParse(addToWishlistEvent);

  if (!result.success) {
    logger.error(result.error, 'Invalid add to wishlist event');
  }

  return addToWishlistEvent;
};
